import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useCommonApi } from '../../api';
import { onSuccessCustomApiResponse } from '../../api/utils';
import { AvailableRentalCars, CarRentalRequest, RentCarRequest } from '../types/rental';

export const useAvailableRentalCar = () => {
  const [availableCars, setAvailableCars] = useState<AvailableRentalCars | undefined>(undefined);

  const { mutate: getAvailableRentCars, isPending: isSearchingRentalCars } = useMutation(
    useCommonApi().getAvailableRentalCars()
  );
  const { mutate: rentCar, isPending: isProcessingRent } = useMutation(useCommonApi().rentCar());

  const handleGetAvailableRentalCars = (params: CarRentalRequest) => {
    getAvailableRentCars(params, {
      onSuccess: onSuccessCustomApiResponse({
        executed: (_, availableCars) => setAvailableCars(availableCars)
      })
    });
  };

  const handleRentCar = (
    rentData: RentCarRequest,
    options?: {
      onSuccess?: () => void;
    }
  ) => {
    rentCar(rentData, {
      onSuccess: onSuccessCustomApiResponse({
        executed: () => {
          setAvailableCars(undefined);
          options?.onSuccess?.();
        }
      })
    });
  };

  return {
    availableCars,
    setAvailableCars,
    isSearchingRentalCars,
    rentCar,
    isProcessingRent,
    handleGetAvailableRentalCars,
    handleRentCar
  };
};
